<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-users-cog"></i> Tipo de Visitas</h3>
      </div>
    </div>
    <VisitTypeAdd v-if="showAdd" ref="VisitTypeAdd" v-on:Back="onBack" />
    <VisitTypeList v-else ref="VisitTypeList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import VisitTypeAdd from './components/add/visittypeadd.vue'
import VisitTypeList from './components/list/visittypelist.vue'

export default {
  name: 'TiposVisitas',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    VisitTypeAdd,
    VisitTypeList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.VisitTypeAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.EventTypeList.onLoad()
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/visit-type/tiposVisitas.vue